import { Injectable } from '@angular/core';
import { ContactDashService } from 'contact-dash';
import { Observable } from 'rxjs';
import { FilterParams, ContactModel, ContactType } from 'starbase-launcher';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class ContactDataService extends ContactDashService {
  protected _toggleFavoriteUri = '/api/Contact/ToggleFavorite?id=';
  protected _delContactLinkingUri = '/api/OrganizationLink';
  protected _addContactLinkingUri = '/api/OrganizationLink';
  protected _getCorrespondenceByContactUri: string; // not used in this app
  protected _getMembershipsByContactUri = '/api/Contact/GetContactMemberships/';
  protected _requisiteUris = [
    {
      name: 'postBackgroundImageUri',
      uri: '/api/Contact/UploadBackgroundImage?contactUID='
    },
    {
      name: 'postAvatarImageUri',
      uri: '/api/Contact/UploadBackgroundImage?contactUID='
    },
    {
      name: 'getAllContactTypesUri',
      uri: '/api/LU_ContactType'
    },
    { name: 'postContactTypeUri', uri: '/api/contactTypeLinks' },
    { name: 'deleteContactTypeUri', uri: '/api/contactTypeLinks/' }
  ];

  protected _staleDataTimeout = 1500;
  protected _getOneUri = '/api/Contact/';
  protected _getAllUri = '/api/Contact';
  protected _getContactsWithUsersUri = '/api/Contact/GetContactsWithUsersByFilterParams';
  protected _postUri = '/api/Contact';
  protected _putUri = '/api/Contact/UpdateContact?id=';
  protected _deleteUri = '/api/Contact/';
  protected _broadSearchUri = '/api/Contact/GetContactsByFilterParams';
  protected _saveNotesUri = '/api/Contact/SaveNotes?id=';
  protected _getAllWithoutInactiveRecordsUri = this.getAllUri + '?includeInactive=false';
  protected _getContactsExcelUri = '/api/Contact/GetContactExcelSheet';
  protected _getCurrentUserUri = '/api/Contact/GetCurrentUserContactModel';
  private readonly _sendEmailToContactUri = '/api/Contact/SendEmailToContact?id=';
  private readonly _sendMassEmailUri = '/api/Contact/SendMassEmail';
  private readonly _saveMassCTsUri = '/api/ContactTypeLinks/AddMass';
  private readonly _saveMassUnassignCTsUri = '/api/ContactTypeLinks/RemoveMass';

  constructor(private _http: HttpClient, private _webApi: WebApiService) {
    super(_http, _webApi);
  }
  public get sendEmailToContactUri() {
 return this._sendEmailToContactUri;
}
  public get sendMassEmailUri() {
 return this._sendMassEmailUri;
}

  getContactsExcel(filterParams: FilterParams<ContactModel>) {
    filterParams.collection = null;
    return this._http.post<File>(
      this.server + this._getContactsExcelUri,
      filterParams,
      { headers: this._webApi.getApiHeaders('post'), responseType: 'blob' as 'json' });
  }


  public saveMassCTAssignment(data: { contactUIDs: number[]; contactTypeUIDs: number[] }): Observable<any> {
    return super.postRequisiteData<ContactType[]>(this._saveMassCTsUri, this.mapCTLinks(data));
  }

  public saveMassCTUnassignment(data: { contactUIDs: number[]; contactTypeUIDs: number[] }): Observable<any> {
    return super.postRequisiteData<ContactType[]>(this._saveMassUnassignCTsUri, this.mapCTLinks(data));

  }

  public getCurrentUser(){
    return this._http.get<ContactModel>(this.server + this._getCurrentUserUri,
      { headers: this._webApi.getApiHeaders('get') }
    );
  }

  private mapCTLinks(data: { contactUIDs: number[]; contactTypeUIDs: number[] }): ContactType[] {
    const mapped: ContactType[] = [];
    data.contactUIDs.forEach(
      a => data.contactTypeUIDs.map(
        // eslint-disable-next-line @typescript-eslint/naming-convention
        t => mapped.push({ uid: 0, contactUID: a, lU_ContactTypeUID: t } as ContactType)));
    return mapped;
  }
}
